
const data = {
    sso_url: window.REACT_APP_SSO_URL,
    sso_clientid: window.REACT_APP_SSO_CLIENT_ID,
    client_callback_url: `${window.location.origin}/tiep-nhan/`,
    client_logout_url: `${window.location.origin}/logout/`,
};
export { data }